import React from 'react';

import { ConfirmationTypes } from '@pharmaplan/common';

import ConfirmationModal from '../../../Modals/ConfirmationModal';

export const getBroadcastGroupLeadConfirmation = (
  confirmAction: () => void,
) =>
  (
    <ConfirmationModal
      confirmAction={confirmAction}
      type={ConfirmationTypes.createBroadcastGroupLeads}
    />
  );
